import { environment } from './../environments/environment';
import { ActivityFn, registerApplication, start, navigateToUrl } from 'single-spa'
import {
  constructApplications, constructLayoutEngine, constructRoutes
} from 'single-spa-layout'
import { SSPA } from '../constants/sspa'
import { ChangeAppEvent } from '../events/changeApp'
import { LogoutEvent } from '../events/logout'
import { ChangeUserProfileEvent } from '../events/userProfile'
import { LoaderService } from '../services/loader.service'
// @ts-ignore
import { AuthService, LocalStorageService, ClientService } from '@cosmos/utilities';
import { ChangeLayoutEvent } from '../events/changeLayout'
import { ChangeLayoutTopbarEvent } from '../events/changeLayoutTopbar'
import { RouteAppChangeEvent } from '../events/routeAppChange'
export class LifecycleOnLoad {
  localStorageService: any;
  clientService: ClientService;

  constructor() {
    this.localStorageService = LocalStorageService.singleton()
    this.clientService = ClientService.singleton()
    this.onLoad()
  }

  private async onLoad() {
    const loaderService = LoaderService.singleton()
    const authService = new AuthService();

    try {
      const clientResponse = await this.clientService.init()
      if(clientResponse == 404) {
        navigateToUrl('/plataforma/nao-encontrado')
      }
      loaderService.show()
      this.setClientData()
      await authService.init()
      this.constructLayout(loaderService)
      this.loadListeners()
      loaderService.hide()
    } catch (error) {
      if(error?.data?.response?.status === 401) {
        authService.logout()
      }
      console.log('error', error)
      loaderService.hide()
    }
  }

  setClientData() {
    // document.title = getPageTitle(getAppName(window.location.href)); TODO merge conflict
    const faviconUrl = this.clientService.getClientDataByKey(this.clientService.parametrosChaves.faviconUrl)
    document.title = (this.clientService.getClientName() || environment.pluriConnect.nome)
    if(!faviconUrl) return

    let faviconLink: any = document.querySelector("link[rel~='icon']")
    if (!faviconLink) {
      faviconLink = document.createElement('link')
      faviconLink.rel = 'icon'
      document.head.appendChild(faviconLink)
    }
    faviconLink.href = faviconUrl
  }

  private constructLayout(loaderService: LoaderService) {

    const data = {
      props: {},
      loaders: {
        semchamada: loaderService.toString('semchamada'),
        corrige: loaderService.toString('corrige'),
        censo: loaderService.toString('censo'),
        agenda: loaderService.toString('agenda'),
        comunicacao: loaderService.toString('comunicacao'),
        loja: loaderService.toString('loja'),
        led: loaderService.toString('led'),
        plataformaPluri: loaderService.toString('plataforma'),
        redacao: loaderService.toString('redacao'),
        chegando: loaderService.toString('chegando')
      },
    }
    //Verifica rotas definidas no index.js
    const routes = constructRoutes(document.querySelector(SSPA.layoutId), data)

    const applications = constructApplications({
      routes,
      loadApp({ name }) {
        return System.import(name)
      },
    })

    //verify authentication
    const toolbar = applications.find(a => a.name === '@cosmos/toolbar')
    const sidenav = applications.find(a => a.name === '@cosmos/sidenav')
    toolbar.activeWhen = this.isLoggedIn
    sidenav.activeWhen = this.isLoggedIn
    constructLayoutEngine({ routes, applications })
    applications.forEach(registerApplication)
    start()
  }

  isLoggedIn: ActivityFn = () => {
    return this.localStorageService.has('usua_perfil_ativo')
  }

  private loadListeners() {
    ChangeUserProfileEvent.init()
    ChangeAppEvent.init()
    LogoutEvent.init()
    ChangeLayoutEvent.init()
    ChangeLayoutTopbarEvent.init();
    RouteAppChangeEvent.init();
  }
}
